// common
import PageLayout from "../common/shell/PageLayout";

export default function Controller() {
    const url = process.env.REACT_APP_MAP_OPGGS_AND_OEI;
    return (
        <PageLayout title={["Interactive Map"]}>
            <iframe
                title="An interactive map presenting the geographical offshore locations of active Titles that exist in Australian territorial waters and other Title related data. The map is presented in an iframe with data sourced from NOPTA's ArcGIS online mapping service."
                src={url}
                style={{ height: "75vh", width: "100%", border: "none" }}
            ></iframe>
        </PageLayout>
    );
}
